import { Injectable } from './service.base';
import { action, makeObservable, observable } from 'mobx';
import { plainToInstance } from 'class-transformer';
import { ModelCreditCard } from '~/models/model.credit.card';
import { ModelUser } from '~/models/model.user';

@Injectable()
export class AddCreditCardService {
    @observable public cardNumberValid = false;
    @observable public cardNumberError = false;
    @observable public expiryDateError = false;
    @observable public cvcError = false;
    @observable public btnDisabled = true;
    @observable public cardSaveOptionChecked = true;
    @observable public showLoading = false;

    @observable public cardHolder: string;

    private touchedFields: Array<string> = [];
    @observable public creditCard: ModelCreditCard = {
        cardHolder: '',
        cardNumber: '',
        cardCvc: '',
    };

    constructor() {
        makeObservable(this);
    }

    @action
    onCardNumberBlur = (cardType: any, erroredInputs: any, event: { target: { value: string } }) => {
        if (cardType && !this.cardNumberError) {
            this.cardNumberValid = true;
            this.creditCard.cardNumber = event.target.value;
            this.creditCard.cardType = cardType.displayName;
        } else {
            this.cardNumberValid = false;
        }
        this.setTouchedFields('card_number');
        this.validateAllFields();
    };

    @action
    onCardNumberError = (cardNumberError: string | undefined) => {
        if (cardNumberError) {
            this.cardNumberError = true;
            this.cardNumberValid = false;
        }
    };

    @action
    onCardNumberFocus = () => {
        this.cardNumberValid = false;
        this.cardNumberError = false;
    };

    @action
    onExpiryDateBlur = (event: { target: { value: string } }) => {
        if (event.target.value) {
            const dateArr: Array<string> = event.target.value.split('/');
            if (dateArr && dateArr.length === 2) {
                const month: string = dateArr[0].trim();
                const shortYear: string = dateArr[1].trim();
                this.creditCard.cardExpiration = `${month}/20${shortYear}`;
            }
        }

        this.setTouchedFields('expiry_date');
        this.validateAllFields();
    };

    @action
    onExpiryDateError = (expiryDateError: string | undefined) => {
        if (expiryDateError) {
            this.expiryDateError = true;
        }
    };

    @action
    onExpiryDateFocus = () => {
        this.expiryDateError = false;
    };

    @action
    onCvcBlur = (event: { target: { value: string } }) => {
        if (event.target.value) {
            this.creditCard.cardCvc = event.target.value;
        }

        this.setTouchedFields('cvc');
        this.validateAllFields();
    };

    @action
    onCvcError = (cvcError: string | undefined) => {
        if (cvcError) {
            this.cvcError = true;
        }
    };

    @action
    onCvcFocus = () => {
        this.cvcError = false;
    };

    @action
    validateAllFields = () => {
        this.btnDisabled =
            this.touchedFields.length < 3 || this.cardNumberError || this.expiryDateError || this.cvcError;
    };

    @action
    setTouchedFields = (fieldName: string) => {
        if (!this.touchedFields.includes(fieldName)) {
            this.touchedFields.push(fieldName);
        }
    };

    @action
    handleCardSaveOptionChange = () => {
        this.cardSaveOptionChecked = !this.cardSaveOptionChecked;
    };

    @action
    onCardHolderBlur = (event: { target: { value: string } }) => {
        if (event.target.value) {
            this.creditCard.cardHolder = event.target.value;
        }
    };

    @action
    setShowLoading = (value: boolean) => {
        this.showLoading = value;
    };

    @action
    setCardNumberValid = (value: boolean) => {
        this.cardNumberValid = value;
    };

    @action
    setCardHolder = (value: string) => {
        this.creditCard.cardHolder = value;
    };

    @action
    setCardNumber = (value: string) => {
        this.creditCard.cardNumber = value;
    };

    @action
    setCardCvc = (value: string) => {
        this.creditCard.cardCvc = value;
    };

    @action
    handleBtnClick = async (onAfterAddCreditCard: (data: Array<object>) => void, currentUser: ModelUser) => {
        if (!this.btnDisabled && this.cardSaveOptionChecked) {
            try {
                this.setShowLoading(true);
                /*const response: AxiosResponse = await api.post(EApiUrl.creditCard, this.creditCard, {
            headers: {
              Authorization: `Bearer ${currentUser.token}`
            }
          });
          if (response.statusText?.toLowerCase() === 'ok') {
            if (response.data?.id) {
              const newCreditCard = plainToInstance(ModelCreditCard, response.data);
              onAfterAddCreditCard([newCreditCard]);
              this.setCardHolder('');
              this.setCardNumber('');
              this.setCardCvc('');

              this.setCardNumberValid(false);
              this.setShowLoading(false);
            }
          }*/
                const data = this.creditCard;
                const newCreditCard = plainToInstance(ModelCreditCard, data);
                onAfterAddCreditCard([newCreditCard]);
                this.setCardHolder('');
                this.setCardNumber('');
                this.setCardCvc('');

                this.setCardNumberValid(false);
                this.setShowLoading(false);
            } catch (error: any) {}
        } else if (!this.btnDisabled) {
            onAfterAddCreditCard([{ ...this.creditCard }]);
            this.setCardHolder('');
            this.setCardNumber('');
            this.setCardCvc('');

            this.setCardNumberValid(false);
        }
    };
}
